import React, { useState } from 'react';
import {
  priorities,
  PRIORITY_IDS
} from 'common/components/AdvancedSearch/AdvancedSearch.constants';
import { PrioritySelector } from 'common/components/AdvancedSearch/components';
import TextBox from 'UI/components/atoms/TextBox';

import { CollapsibleChipFilter } from '../CollapsibleChipFilter';

import { useStyles } from './TextFilter.styled';

const DEFAULT_ITEM_ID = 'text-filter';

const getPriorityLabel = id => (priorities.find(p => p.id === id) || {}).shortLabel || '';

export const TextFilter = ({
  fieldName,
  name,
  onChange,
  placeholder,
  title,
  transform,
  value,
  itemId = DEFAULT_ITEM_ID
}) => {
  const classes = useStyles();
  const [priority, setPriority] = useState(PRIORITY_IDS.MustHave);

  const currentText = value?.item?.value ?? '';
  const currentPriority = value?.priority ?? priority;

  const notify = (text, nextPriority) => {
    const p = nextPriority ?? currentPriority;
    if (!text) {
      setPriority(p);
      onChange(name, { fieldName, value: null });
      return;
    }
    onChange(name, {
      fieldName,
      value: { item: { value: text }, priority: p, isSingleValue: true }
    });
  };

  const handleInputChange = (_key, val) => {
    const transformed = transform ? transform(String(val ?? '')) : String(val ?? '');
    notify(transformed, currentPriority);
  };

  const handlePriorityChange = p => {
    notify(currentText || null, p);
  };

  const handleClear = () => {
    onChange(name, { fieldName, value: null });
  };

  const pseudoItem = currentText
    ? { id: itemId, item: { value: currentText }, priority: currentPriority }
    : null;

  return (
    <CollapsibleChipFilter
      title={title}
      triggerLabel={placeholder}
      showClear={value !== null}
      onClear={handleClear}
      chipItem={pseudoItem}
      getChipLabel={i => i.value}
      getChipPriorityLabel={getPriorityLabel}
      priorities={priorities}
      onPriorityChange={handlePriorityChange}
    >
      {({ isExpanded }) =>
        isExpanded && (
          <div className={classes.selectorsRow}>
            <div className={classes.inputWrapper}>
              <TextBox
                label={title}
                name={name}
                onChange={handleInputChange}
                placeholder={placeholder}
                value={currentText}
                noMargin
              />
            </div>
            <PrioritySelector
              priorities={priorities}
              selectedPriority={currentPriority || PRIORITY_IDS.MustHave}
              onPriorityChange={handlePriorityChange}
              size="small"
            />
          </div>
        )
      }
    </CollapsibleChipFilter>
  );
};
